import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataGridTable } from '@/ui'
import styles from './EmployeeInformation.module.scss'
import { useSelector } from 'react-redux'
import { staffingSelectors } from '@/entity'
import { formatNumber } from '@/utils'
import { LANGUAGE_ENUM } from '@/shared'
import { employerProfileSelectors } from '@features/employerProfile/model'
import { getCurrentLanguage } from '@/i18next'

export const EmployeeInformation = ({ position, workPlaceRowSelect }) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()

	const activeCompany = useSelector(employerProfileSelectors.activeCompany)

	const wplaceEmployeeList = useSelector(staffingSelectors.wplaceEmployeeList)


	const getSubstitutionNameForId = (substitutionExternalId) => {
		const substitution = wplaceEmployeeList.find((item) => item.externalId === substitutionExternalId)
		return {
			substitutionName: substitution ? substitution.fullName : '',
		}
	}

	const employeeInformation = () => {
		const level = {
			[LANGUAGE_ENUM.kz]: position?.level?.nameKz || '-',
			[LANGUAGE_ENUM.rus]: position?.level?.nameRu || '-',
		}
		const experience = {
			[LANGUAGE_ENUM.kz]: position?.experience?.nameKz || '-',
			[LANGUAGE_ENUM.rus]: position?.experience?.nameRu || '-',
		}
		const unit = {
			[LANGUAGE_ENUM.kz]: position?.unit?.nameKz || '-',
			[LANGUAGE_ENUM.rus]: position?.unit?.nameRu || '-',
		}

		return [
			{ title: t('contracts_tab.employee_fio'), data: position.fullName || '' },
			{
				title: t('staff.substitute_fio'),
				data: getSubstitutionNameForId(position.substitutionExternalId).substitutionName || '',
			},
			{ title: t('positions_combination'), data: position.isCombining ? t('yes') : t('no') || '' },
			{ title: t('workplace.tariff_rate'), data: position.tariffRate || '' },
			{ title: t('staffing_table.sum'), data: formatNumber(position.factSalary || '') || '' },
			{
				title: t('staffing_table.supplement_surcharge'),
				data: formatNumber(position.salarySupplement || '') || '',
			},
			{ title: t('payment.table.appointmentDate'), data: position.beginDate || '' },
			{ title: t('contracts_tab.end_contract_date'), data: position.endDate || '' },
			{ title: t('staffing_table.reason_temporary'), data: position.reasonForAbsence || '' },
			...(activeCompany?.msu ? [
				{ title: t('level'), data: level[lang] },
				{ title: t('experience'), data: experience[lang] },
				{ title: t('unit'), data: unit[lang] },
			] : []),
			...(workPlaceRowSelect.isWithoutContract ? [
				{ title: t('without_td'), data: position?.delegatingOrgBin ? t('delegatingBin', {bin: position?.delegatingOrgBin}) : t('no')  },
			]: [])
		]
	}
	return (
		<DataGridTable
			hideSubTitle
			titleClass={styles.tableTitleCell}
			title={t('workplace.information_prescribing')}
			information={employeeInformation()}
		/>
	)
}
